const HazardsGasStep = () => {
  return (
    <div className="space-y-6">
      <h3 className="text-lg font-medium text-primary-500">
        Hazards & Gas Readings
      </h3>
      <p className="text-sm text-neutral-500">
        Review hazards and define required initial gas readings before issuing
        this permit.
      </p>

      <div className="rounded-lg border border-neutral-200 p-8 text-center text-sm text-neutral-500">
        Gas readings configuration and Hazard review will be displayed here.
      </div>
    </div>
  );
};

export default HazardsGasStep;
